var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "qrcode__img--container qrcode--hide" }, [
    !_vm.refetchEnabled
      ? _c(
          "div",
          { staticClass: "qrcode__img--time" },
          [
            _c("jade-spinner", {
              attrs: { size: _vm.SIZE_ENUM.SMALL, color: _vm.COLOR_ENUM.BRAND },
            }),
            _c("jade-text", [_vm._v(" " + _vm._s(_vm.$t("time-text")) + " ")]),
            _c(
              "jade-text",
              { attrs: { color: _vm.COLOR_ENUM.BRAND, weight: "semibold" } },
              [_vm._v(" " + _vm._s(_vm.parsedCountdown) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "qrcode--container" },
      [
        _c("div", {
          ref: "img",
          staticClass: "qrcode__img",
          class: { "qrcode--opacity": _vm.refetchEnabled },
          style: {
            "background-image": `url('data:image/svg+xml;base64,${
              !!_vm.kycQrCode && _vm.kycQrCode.base64_qrcode
            }')`,
          },
        }),
        _vm.refetchEnabled
          ? _c(
              "jade-button",
              {
                staticClass: "qrcode__button",
                attrs: {
                  icon: "action-refresh",
                  loading: _vm.loadingKycQrCode,
                  size: _vm.SIZE_ENUM.SMALL,
                  variant: "primary-solid",
                },
                on: { click: _vm.retryQrCode },
              },
              [_vm._v(" " + _vm._s(_vm.$t("new-qr-code")) + " ")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }